import React, { Suspense } from "react";
import PropTypes from "prop-types";
import Error from "../Error";
import { createUseStyles, useTheme } from "react-jss";
import { useGlobalContext } from "../Context";
var BrightcovePlayer = React.lazy(function () { return import("./BrightcovePlayer"); });
var Video = function (_a) {
    var vendorVideosCollection = _a.vendorVideosCollection, vendorVideos = _a.vendorVideos, graphQLResponse = _a.graphQLResponse;
    var vendor = useGlobalContext().vendor;
    var theme = useTheme();
    var useStyles = createUseStyles(function (theme) {
        var _a;
        var getBackgroundColor = function () {
            var _a;
            var backgroundColor = "#FFFFFF";
            if (graphQLResponse &&
                vendorVideosCollection &&
                vendorVideosCollection.items) {
                // @ts-ignore
                backgroundColor = vendorVideosCollection.items.find(function (video) { return video.vendor === vendor; }).backgroundColor;
            }
            else if (vendorVideos) {
                backgroundColor = (_a = vendorVideos.find(function (video) { return video.fields.vendor === vendor; })) === null || _a === void 0 ? void 0 : _a.fields.backgroundColor;
            }
            return backgroundColor;
        };
        return {
            root: {
                position: "relative",
                display: "block",
                width: "100%",
                height: "auto",
                backgroundColor: getBackgroundColor() || "inherit",
                overflow: "hidden",
                margin: "0 auto",
            },
            container: (_a = {
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "100%",
                    height: "auto",
                    padding: 0,
                    backgroundColor: getBackgroundColor() || "inherit",
                    overflow: "hidden",
                    maxWidth: theme.maxWidth,
                    margin: "0 auto"
                },
                _a[theme.mediaQuery(theme.breakpoints.medium)] = {
                    padding: "80px 80px 60px",
                },
                _a["& .brightcove-react-player-loader"] = {
                    maxWidth: "100%",
                    height: "100%",
                    width: "100%",
                },
                _a),
        };
    });
    var classes = useStyles({ theme: theme });
    var video;
    if (graphQLResponse && vendorVideosCollection) {
        video = vendorVideosCollection.items.find(function (video) { return video.vendor === vendor; });
    }
    else if (vendorVideos) {
        video = vendorVideos.find(function (video) { return video.fields.vendor === vendor; });
    }
    else {
        return null;
    }
    if (!video) {
        return null;
    }
    var _b = !graphQLResponse ? video.fields : video, brightcoveAccountId = _b.brightcoveAccountId, _c = _b.brightcovePlayerId, brightcovePlayerId = _c === void 0 ? "3x0DtrVmL" : _c, brightcoveVideoId = _b.brightcoveVideoId;
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.container },
            React.createElement(Error, null,
                React.createElement(Suspense, { fallback: React.createElement("div", null, "Loading...") },
                    React.createElement(BrightcovePlayer, { options: {
                            accountId: brightcoveAccountId,
                            playerId: brightcovePlayerId,
                            videoId: brightcoveVideoId,
                        } }))))));
};
Video.defaultProps = {
    vendorVideos: [],
    graphQLResponse: false,
};
Video.propTypes = {
    vendorVideos: PropTypes.array.isRequired,
    graphQLResponse: PropTypes.bool,
};
export default Video;
